import React from 'react'
import PieChart from 'highcharts-react-official'
import Highcharts from 'highcharts/highcharts'

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

const toTon = (value) => Math.round((+value || 0) / 1000)

// กราฟเทียบเป้าหมายการผลิต vs เมล็ดดี แบบแกน log — ใช้ร่วมทุกมุมมอง (กลุ่มข้าว/ศูนย์/พันธุ์)
export default function ComparisonBarChart({ items, height }) {
    // เรียงตามเป้าหมายจากน้อยไปมาก
    const sorted = [...(items || [])].sort((a, b) => (+a.Target || 0) - (+b.Target || 0))

    // แกน log ห้ามมีค่า 0 — แปลงเป็น null เพื่อไม่วาดแท่ง
    const toLogValue = (value) => toTon(value) > 0 ? toTon(value) : null

    const chartHeight = height || Math.max(320, sorted.length * 30)

    const options = {
        chart: { type: 'bar', height: chartHeight },
        title: { text: '' },
        xAxis: {
            categories: sorted.map((x) => x.Name),
            title: null,
        },
        yAxis: {
            type: 'logarithmic',
            min: 1,
            title: null,
            labels: {
                formatter: function () {
                    return this.value?.toLocaleString();
                }
            },
        },
        legend: { enabled: true },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormatter: function () {
                return `${this.series.name}: <b>${this.y?.toLocaleString()}</b><br/>`
            }
        },
        plotOptions: {
            series: {
                grouping: false,
                borderWidth: 0,
            }
        },
        series: [
            {
                name: 'เป้าหมายการผลิต (ตัน)',
                type: 'bar',
                color: '#C5E0B4',
                pointWidth: 24,
                data: sorted.map((x) => toLogValue(x.Target)),
                dataLabels: {
                    enabled: true,
                    inside: false,
                    color: '#666',
                    formatter: function () {
                        return this.y?.toLocaleString()
                    }
                }
            },
            {
                name: 'เมล็ดดี',
                type: 'bar',
                color: '#375623',
                pointWidth: 12,
                data: sorted.map((x) => toLogValue(x.Actual)),
                dataLabels: {
                    enabled: true,
                    inside: true,
                    color: '#fff',
                    style: { fontWeight: 'bolder', textOutline: 'none' },
                    formatter: function () {
                        return this.y?.toLocaleString()
                    }
                }
            },
        ]
    }

    return (
        <PieChart options={options} highcharts={Highcharts} />
    )
}
